import { type LoaderFunctionArgs } from '@remix-run/node';

export const loader = async (_args: LoaderFunctionArgs) => {
    return null;
};

export default function Index() {
    return (
        <div
            style={{
                padding: '2rem',
                fontFamily: 'system-ui, sans-serif',
                textAlign: 'center',
            }}
        >
            <h1>🚀 Express POS API</h1>
            <p>API is running and ready</p>

            <div
                style={{
                    backgroundColor: '#f0f8ff',
                    border: '1px solid #0066cc',
                    borderRadius: '8px',
                    padding: '1rem',
                    marginTop: '2rem',
                    maxWidth: '600px',
                    margin: '2rem auto',
                }}
            >
                <h2>Available</h2>
                <ul style={{ textAlign: 'left', display: 'inline-block' }}>
                    <li>
                        <code>GET /</code> - This page
                    </li>
                    <li>
                        <code>GET /api/terminals</code> - List payment terminals
                    </li>
                    <li>
                        <code>GET /auth?shop=your-shop.myshopify.com</code> - Start auth flow
                    </li>
                </ul>
            </div>
        </div>
    );
}
